var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldSwitch, FormField, FormGrid, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, Form, getFormValues, reduxForm, } from 'redux-form';
import { selectSortedQueuesByName } from 'app/utils/reselect';
import { FlowNodeTypes, } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { QueuePicker } from 'components/shared/queuePicker';
import { getRequestID } from 'components/shared/util/request';
import { durationConverter } from 'utils/duration';
import styles from './queue.module.scss';
import { TimeoutFields } from './queue/timeoutFields';
const validate = (values) => {
    var _a;
    const errors = {};
    if (!values) {
        return errors;
    }
    if (!((_a = values.queue) === null || _a === void 0 ? void 0 : _a.value)) {
        errors.queue = {
            value: 'Selecting a queue is required',
        };
    }
    if (values.queue_timeout && !values.queue_timeout.timeout_in_seconds) {
        errors.queue_timeout = {
            timeout_in_seconds: 'Please set a timeout value',
        };
    }
    return errors;
};
class QueueModalImpl extends PureComponent {
    handleSaveClick(values) {
        var _a, _b, _c, _d, _e;
        const { queuesState } = this.props;
        let selectedQueue = null;
        // Find queue in queues.
        if (typeof ((_a = values.queue) === null || _a === void 0 ? void 0 : _a.value) === 'string') {
            for (const queue of queuesState) {
                if (queue.id === values.queue.value) {
                    selectedQueue = {
                        value: queue.id,
                        label: queue.name,
                    };
                }
            }
        }
        /*
         * With the new modals the QueuePicker component returns an object.
         * Once the feature flag is lifted, this condition can be simplified
         * and the above string comparison removed.
         */
        if (typeof ((_b = values.queue) === null || _b === void 0 ? void 0 : _b.value) === 'object') {
            const { value } = values.queue;
            const queue = value;
            selectedQueue = {
                value: queue.id,
                label: queue.name,
            };
        }
        const payload = Object.assign(Object.assign({}, this.props.node.payload), { queue: selectedQueue });
        const timeoutInSeconds = (_c = values.queue_timeout) === null || _c === void 0 ? void 0 : _c.timeout_in_seconds;
        if (timeoutInSeconds) {
            const { ss, mm, hh, dd } = timeoutInSeconds;
            const totalSecounds = durationConverter.combineTimeUnits(dd ? parseInt(dd, 10) : 0, hh ? parseInt(hh, 10) : 0, mm ? parseInt(mm, 10) : 0, ss ? parseInt(ss, 10) : 0);
            if (totalSecounds > 0) {
                payload.queue_timeout = {
                    timeout_in_seconds: totalSecounds,
                    timeout_node_id: ((_e = (_d = this.props.node.payload) === null || _d === void 0 ? void 0 : _d.queue_timeout) === null || _e === void 0 ? void 0 : _e.timeout_node_id) ||
                        getRequestID(),
                };
            }
        }
        else {
            delete payload.queue_timeout;
        }
        const nodeOptions = Object.assign(Object.assign({}, this.props.node), { badges: [], childIds: [], icon: 'i-queue', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.QUEUE, overlay: [], payload, text: `Queue ${typeof (selectedQueue === null || selectedQueue === void 0 ? void 0 : selectedQueue.label) === 'string'
                ? `(${selectedQueue.label})`
                : ''}` });
        this.props.replaceNode(nodeOptions);
        this.props.triggerClose();
    }
    render() {
        const { formValues, handleSubmit, node, nodeLabel, triggerClose, dirty: isChanged, } = this.props;
        const { payload } = node;
        return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: triggerClose }, { children: _jsx("div", Object.assign({ className: styles.description }, { children: "The queue is where you\u2019d like your incoming conversations to end up based on the queues you\u2019ve set up. Haven\u2019t made any custom queues yet? Go to Settings > Queues > Add queue" })) })), _jsxs(Form, Object.assign({ onSubmit: handleSubmit(this.handleSaveClick) }, { children: [_jsxs(ModalBody, { children: [_jsx(Field, { component: QueuePicker, label: "Select queue", name: "queue.value", placeholder: "No queue selected", selectedQueue: payload === null || payload === void 0 ? void 0 : payload.queue, required: true }), _jsxs(FormGrid, Object.assign({ className: styles.timeout }, { children: [_jsxs(FormField, Object.assign({ className: styles.timeoutField }, { children: [_jsx("label", Object.assign({ className: styles.timeoutLabel, htmlFor: "fieldSwitch" }, { children: "Timeout" })), _jsx(Field, { checked: !!(formValues === null || formValues === void 0 ? void 0 : formValues.queue_timeout), className: styles.fieldSwitch, component: FieldSwitch, id: "fieldSwitch", label: "Outbound call recording", name: "queue_timeout" })] })), (formValues === null || formValues === void 0 ? void 0 : formValues.queue_timeout) && (_jsx(FormField, { children: _jsx(Field, { name: "queue_timeout.timeout_in_seconds", component: TimeoutFields }) }))] }))] }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(this.handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: triggerClose })] }))] })));
    }
}
__decorate([
    boundMethod
], QueueModalImpl.prototype, "handleSaveClick", null);
const mapStateToProps = (state, ownProps) => {
    var _a;
    const payload = Object.assign({ queue: null }, ownProps.node.payload);
    const initialValues = Object.assign(Object.assign({}, payload), { queue_timeout: undefined });
    const timeoutInSeconds = (_a = payload === null || payload === void 0 ? void 0 : payload.queue_timeout) === null || _a === void 0 ? void 0 : _a.timeout_in_seconds;
    if (timeoutInSeconds) {
        const { days, hours, minutes, seconds } = durationConverter.splitTimeUnits(timeoutInSeconds, true);
        initialValues.queue_timeout = {
            timeout_in_seconds: {
                dd: (days !== null && days !== void 0 ? days : 0).toString(),
                hh: hours.toString(),
                mm: minutes.toString(),
                ss: seconds.toString(),
            },
        };
    }
    return {
        queuesState: selectSortedQueuesByName(state),
        initialValues,
        formValues: getFormValues('emailFlowQueueForm')(state),
    };
};
export const QueueModal = connect(mapStateToProps)(reduxForm({
    form: 'emailFlowQueueForm',
    enableReinitialize: true,
    touchOnBlur: false,
    validate,
})(QueueModalImpl));
